/*************************************************************************
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React, { Component } from "react";
import PropTypes from "prop-types";

class DialogContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }

  componentDidMount() {
    /* Spectrum dialog in open state is selected using query selector, if spectrum dialog class name is changed,
      we need to update the class name used by querySelector accordingly. 
    */

    const dialogNode = document.querySelector(".spectrum-Dialog.is-open");
    if (dialogNode) {
      Object.assign(dialogNode.style, this.props.dialogStyle);

      if (window.screen.width <= 320) {
        dialogNode.style.padding = "20px";
        // To make sure dialog box leaves a margin of 20px on both sides
        const dialogWidthPercent = (1 - 40 / window.screen.width) * 100;
        dialogNode.style.minWidth = `${dialogWidthPercent}%`;
      }
    }
  }

  setDialogHasError(value) {
    this.setState(prevState => ({
      ...prevState,
      hasError: value
    }));
  }

  render() {
    const { DialogComponent, ...remainingProps } = this.props;
    return (
      <DialogComponent hasError={this.state.hasError} {...remainingProps} />
    );
  }
}

DialogContainer.defaultProps = {
  dialogStyle: {}
};

DialogContainer.propTypes = {
  DialogComponent: PropTypes.element.isRequired,
  dialogStyle: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  )
};

export default DialogContainer;
